import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetSelfSentimentReportRequestDto } from '../../../../interface/dtos/sentiment/get-self-sentiment-report.request.dto';
import { SelfSentimentReportEntity } from '../../../domain/entities/sentiment/self-sentiment-report.entity';
import { SentimentReportPort } from '../../ports/sentiment/sentiment-report.port';

export class GetSelfSentimentReportApplicationService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly port: SentimentReportPort
  ) {}

  async execute(
    props: GetSelfSentimentReportRequestDto
  ): Promise<SelfSentimentReportEntity> {
    try {
      return await this.port.getSelfSentimentReportForDate({
        reportType: props.params.reportType,
        date: props.params.date,
        token: props.config.token,
      });
    } catch (error) {
      throw new Error(
        `GetSelfSentimentReportService.execute encountered an error ${error}`
      );
    }
  }
}
